import React from "react";
import logo from "../images/logo.png";

const PaymentProcessingState = () => {
	return (
		<div className="bg-white min-h-screen flex flex-col items-center justify-center px-4 py-6">
			{/* Logo */}
			<div className="flex flex-col items-center mb-8">
				<img
					src={logo}
					alt="Pebble Spaces Logo"
					className="w-40 h-auto object-contain"
				/>
			</div>

			{/* Payment Processing Card */}
			<div className="bg-blue-50 border-2 border-blue-200 rounded-3xl p-8 mb-6 w-full max-w-sm text-center">
				{/* Animated Spinner */}
				<div className="flex justify-center mb-6">
					<div className="relative">
						<div className="w-16 h-16 border-4 border-blue-200 rounded-full"></div>
						<div className="absolute top-0 left-0 w-16 h-16 border-4 border-blue-600 rounded-full border-t-transparent animate-spin"></div>
					</div>
				</div>

				{/* Processing Message */}
				<h2 className="text-2xl font-bold text-black mb-3">
					Processing Payment
				</h2>
				<p className="text-base text-gray-700 mb-4">
					We're finalizing your session and processing your payment.
				</p>
				<p className="text-sm text-gray-600">This will only take a moment...</p>
			</div>

			{/* Reassurance Message */}
			<div className="w-full max-w-sm text-center">
				<p className="text-sm text-gray-500">
					Your receipt will be texted to you shortly. You may safely close this
					browser window.
				</p>
			</div>

			{/* Animated dots background */}
			<div className="fixed inset-0 pointer-events-none overflow-hidden -z-10">
				<div className="absolute top-1/4 left-1/4 w-2 h-2 bg-blue-400 rounded-full opacity-20 animate-pulse"></div>
				<div
					className="absolute top-1/3 right-1/4 w-3 h-3 bg-blue-300 rounded-full opacity-20 animate-pulse"
					style={{ animationDelay: "0.5s" }}
				></div>
				<div
					className="absolute bottom-1/4 left-1/3 w-2 h-2 bg-blue-400 rounded-full opacity-20 animate-pulse"
					style={{ animationDelay: "1s" }}
				></div>
				<div
					className="absolute bottom-1/3 right-1/3 w-3 h-3 bg-blue-300 rounded-full opacity-20 animate-pulse"
					style={{ animationDelay: "1.5s" }}
				></div>
			</div>
		</div>
	);
};

export default PaymentProcessingState;
